"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoContainer = exports.Title = exports.Section = exports.Hero = exports.ChildrenContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const VideoContainer = _styledComponents.default.div`
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    pointer-events: none;
  }
`;
exports.VideoContainer = VideoContainer;
const Hero = _styledComponents.default.div`
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  background-image: url('${props => props.backgroundImage}');
  background-size: cover;
  background-position: center center;

  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transition: 0.35s all;
    background-color: ${props => props.backgroundColor || 'rgba(0, 0, 0, 1)'};
    opacity: 0;
  }

  &.is-active {
    &:after {
      opacity: 0.65;
    }
  }
`;
exports.Hero = Hero;
const ChildrenContainer = _styledComponents.default.div`
  padding-top: 100vh;
  position: relative;
  z-index: 2;
`;
exports.ChildrenContainer = ChildrenContainer;
const Title = _styledComponents.default.h4`
  font-family: 'univers-black', sans-serif;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  font-size: 36px;
  color: white;
  position: relative;
  z-index: 1;
  margin: 0px;
  transition: 0.25s all;

  @media (min-width: 768px) {
    font-size: 32px;
  }

  @media (min-width: 1200px) {
    font-size: 48px;
  }
`;
exports.Title = Title;
const Section = _styledComponents.default.section`
  position: relative;
  color: ${props => props.textColor || 'inherit'};

  p {
    a {
      text-decoration: none !important;
      color: white;
      border-bottom: 1px solid ${props => props.textColor || 'inherit'};
      transition: 0.15s all;

      &:hover {
        opacity: 0.75;
      }
    }
  }

  a.bricks-cta {
    color: ${props => props.textColor || 'inherit'};
    border: 1px solid ${props => props.textColor || 'inherit'};

    &:hover {
      color: ${props => props.backgroundColor || 'inherit'};
      background-color: ${props => props.textColor || 'inherit'};
    }
  }

  a.shopping-carousel {
    color: ${props => props.textColor || 'inherit'};
    text-decoration: none;
  }

  div.credits-container {
    border-top: 1px solid ${props => props.textColor || 'inherit'};
    svg path {
      stroke: ${props => props.textColor || 'inherit'};
    }
  }
`;
exports.Section = Section;
//# sourceMappingURL=styles.js.map